module.exports = __webpack_public_path__ + "assets/img/36_1497.f40f6bc0.jpg";